// SurveyRedirect.jsx
import { useEffect } from 'react';
import { motion } from 'framer-motion';

const Tutorials = () => {
    useEffect(() => {
        const timer = setTimeout(() => {
            window.location.href = 'https://www.youtube.com/playlist?list=PLdfJm-tPKyeU';
        }, 1500); // 2000ms = 2 seconds

        return () => clearTimeout(timer); // cleanup if component unmounts early
    }, []);

    return (
        <div className="flex justify-center items-center h-screen bg-white">
            <div className="flex space-x-2">
                {[0, 1, 2].map((i) => (
                <motion.span
                    key={i}
                    className="w-4 h-4 bg-black rounded-full"
                    animate={{ y: [0, -10, 0] }}
                    transition={{
                    duration: 0.6,
                    repeat: Infinity,
                    ease: 'easeInOut',
                    repeatType: 'loop',
                    delay: i * 0.2,
                    }}
                />
                ))}
            </div>
        </div>
  );
};

export default Tutorials;